export default {
  descricao: {
    value: null,
    maxlength: 100,
    required: true,
    state: null
  },
  dataInicial: {
    value: null,
    required: true,
    state: null
  },
  dataFinal: {
    value: null,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/reports/pdrreportevaluationmember/pdrreportevaluationmember-form.js